import React, {useMemo, useState} from "react";
import {Box, Tooltip} from "@mui/material";
import {MaterialReactTable} from "material-react-table";
import MenuItem from "@mui/material/MenuItem";
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import ModalAlert from "../ModalAlert";
import {COLORS, constantsErrorMessages} from "../../../../../Constants";
import {gluing} from "../../../../../data/Gluing";
import CellShortenedName from "../../orders/organization/estimate/CellShortenedName";

const ProcessingEdgesTable = ({usedEdges}) => {
    const columns = useMemo(() => {
        const baseColumns = [
            {
                header: 'Цвет', accessorKey: 'color', size: 1, grow: false,
                Cell: ({cell}) => <Box style={{
                    width: "18px",
                    height: "18px",
                    borderRadius: "1px",
                    backgroundColor: COLORS[cell.getValue()][400],

                }}/>
            },
            {
                header: 'Артикул', accessorKey: 'materialArticleNumber', size: 150,
                Cell: ({cell}) => <CellShortenedName
                    value={cell.getValue()}
                    numberOfCharacters={20}
                />,
            },
            {
                header: 'Наименование', accessorKey: 'materialName', minSize: 380,
            },
            {
                header: 'Тип поклейки', accessorKey: 'edgeType', size: 120,
                Cell: ({cell}) => gluing[cell.getValue()],
            },
        ];

        return baseColumns;

    }, [usedEdges]);


    return <>
        <MaterialReactTable
            selectAllMode={"all"}
            // muiTablePaperProps={{
            //     sx: {
            //         boxShadow: "none"
            //     }
            // }}

            muiTableBodyCellProps={{
                sx: {
                    p: '0px 0px 0px 10px',
                    m: '0px 0px 0px 0px',
                    border: "none",
                    "&:after": {
                        display: "none",
                    },
                    "&:not(:last-of-type)": {
                        borderRight: '1px solid #EAEBEA',

                    },
                },
            }}
            muiTableHeadCellProps={{
                sx: {
                    border: '1px solid #EAEBEA',
                    backgroundColor: "#F5F6FA",
                    padding: "10px",
                    paddingBottom: " 0.2rem",
                    paddingTop: "0.2rem",
                },
            }}
            muiTableBodyRowProps={({row}) => {
                return ({
                    sx: () => ({
                        height: '36px',
                        backgroundColor: "white",
                        "&:hover& td:after": {
                            display: "none",
                        },
                        "&.MuiTableRow-root.Mui-selected": {
                            backgroundColor: (theme) => theme.palette.primary.light70,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.light50,
                            },
                        },
                        "&:hover": {
                            "& td:after": {
                                display: "none",
                            },
                            backgroundColor: (theme) => theme.palette.primary.stroke,
                        },
                        '&:nth-of-type(even)': {
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            backgroundColor: (theme) => theme.palette.primary.lightGrey,
                            "&:hover": {
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                        },
                    })
                })
            }}
            columns={columns}
            data={usedEdges}
            rowHeight={13}
            columnSpacing={1}
            initialState={{
                density: "compact",
            }}
            getRowId={(originalRow) => originalRow.id}
            selectionPadding={1}
            selectionCss={{
                backgroundColor: 'lightblue',
                borderWidth: '2px',
                borderStyle: 'solid',
                borderColor: 'blue',
                borderRadius: '4px',
            }}

            localization={MRT_Localization_RU}
            enableBottomToolbar={false}
            enableTopToolbar={false}
            enableColumnActions={false}
            enableSorting={false}
        />
    </>

}
export default ProcessingEdgesTable